import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.3643 6.07324L5.63634 18.8012",
		stroke: "white",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.3643 18.8008L5.63634 6.07286",
		stroke: "white",
		strokeWidth: 1.5
	})]
});
export default SvgReject;
